import {ZERO_DECIMALS_CURRENCIES} from '../constants';

export const convertPriceToNumber = (price: string): number => {
  // Remove all characters except digits, dots, and commas
  const cleanPrice = price.trim().replace(/[^0-9,.]/g, '');

  // Handle European number format (e.g., "1.234,56")
  const isEuropeanFormat = cleanPrice[cleanPrice.length - 3] === ',';

  return isEuropeanFormat
    ? parseFloat(cleanPrice.replace(/\./g, '').replace(/,([^,]*)$/, '.$1'))
    : parseFloat(cleanPrice.replace(/,/g, ''));
};

interface FormatPriceProps {
  currencyCode?: string;
  price: number;
}

export const formatPrice = ({
  currencyCode = 'USD',
  price,
}: FormatPriceProps): string => {
  const fractionDigits = ZERO_DECIMALS_CURRENCIES.includes(currencyCode)
    ? 0
    : 2;

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };

  // in rare cases, intl is not available in the browser
  // if this happens, we fallback to a simple format
  if (typeof Intl === 'undefined' || typeof Intl.NumberFormat === 'undefined') {
    return `${price.toFixed(fractionDigits)} ${currencyCode}`;
  }

  // Try to use narrowSymbol first, fall back to symbol if not supported
  try {
    options.currencyDisplay = 'narrowSymbol';
    return new Intl.NumberFormat(undefined, options).format(price);
  } catch (narrowSymbolError) {
    options.currencyDisplay = 'symbol';
    return new Intl.NumberFormat(undefined, options).format(price);
  }
};
